import React from 'react';
import { Box, LinearProgress, Tooltip, Typography } from '@mui/material';
import { formatGrams, remainingPercent, stockSeverity } from '../../helpers/filaments';

/**
 * Mostra quanto resta de um carretel. O peso do carretel é o valor nominal e não
 * muda; o que se move é o peso atual, debitado pelas impressões.
 */
function FilamentStockBar({ currentWeight, spoolWeight, showCaption = true, width }) {
    const current = Number(currentWeight) || 0;
    const spool = Number(spoolWeight) || 0;
    const percent = remainingPercent(current, spool);
    const severity = stockSeverity(current, spool);

    const caption = current < 0
        ? `${formatGrams(current)} — saldo negativo`
        : `${formatGrams(current)} de ${formatGrams(spool)}`;

    const tooltip = current < 0
        ? 'O saldo está negativo, o que indica que o peso atual cadastrado está desatualizado.'
        : `${Math.round(percent)}% restante`;

    return (
        <Box sx={{ minWidth: width || 120 }}>
            <Tooltip title={tooltip}>
                <LinearProgress
                    variant="determinate"
                    value={percent}
                    color={severity}
                    sx={{ height: 6, borderRadius: 3 }}
                />
            </Tooltip>
            {showCaption && (
                <Typography
                    variant="caption"
                    color={current <= 0 ? 'error.main' : 'text.secondary'}
                    sx={{ display: 'block', mt: 0.5 }}
                >
                    {caption}
                </Typography>
            )}
        </Box>
    );
}

export default FilamentStockBar;
